<template>
  <section>
    <b-row>
      <Product
        v-for="item in items"
        :key="item.id"
        :item="item"
        @open-preview="openImagePreview"
      />
    </b-row>

    <b-modal
      v-model="showImagePreview"
      centered
      hide-footer
      title="Urun Gorseli"
    >
      <div class="preview-wrapper">
        <img
          :src="activeImageUrl"
          alt="Product Preview"
          class="preview-image"
        >
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Product from './Product.vue'

export default {
  name: 'ListProduct',
  components: {
    Product,
  },
  props: {},
  data() {
    return {
      showImagePreview: false,
      activeImageUrl: '',
    }
  },
  computed: {
    ...mapGetters('tySearchProduct', {
      contentFromStore: '_content',
      selectedBrandsFromStore: '_selectedBrands',
      selectedCategoriesFromStore: '_selectedCategories',
    }),
    items() {
      const selectedBrandIds = this.selectedBrandsFromStore
        .map(brand => Number(brand.key ?? brand.id))
        .filter(Number.isFinite)

      const selectedCategoryIds = this.selectedCategoriesFromStore
        .map(category => Number(category.key ?? category.id))
        .filter(Number.isFinite)

      return this.contentFromStore.filter(item => {
        const itemBrandId = Number(item?.product?.brand?.id)
        const itemCategoryId = Number(item?.product?.category?.id)

        const brandMatch = !selectedBrandIds.length || selectedBrandIds.includes(itemBrandId)
        const categoryMatch = !selectedCategoryIds.length || selectedCategoryIds.includes(itemCategoryId)

        return brandMatch && categoryMatch
      })
    },

  },
  methods: {
    openImagePreview(imageUrl) {
      this.activeImageUrl = imageUrl
      this.showImagePreview = true
    },
  },
}
</script>

<style scoped>
.preview-wrapper {
  display: flex;
  justify-content: center;
}

.preview-image {
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
}
</style>
